import {createSelector} from "reselect";

const baseData = (state) => state.general;

export const getOrganization = createSelector(baseData, (data) =>
  data.organization ? data.organization : null
);

export const getOrganizationImages = createSelector(baseData, (data) => {
  const images = data.organizationImages || {};
  return {
    backgroundImg: images.background || "",
    logoImg: images.logo || "",
    background_type: images.background_type,
  };
});

export const getCustomerListDetails = createSelector(baseData, (data) => data.customers);

export const getCustomers = createSelector(baseData, (data) => data.customers);

export const getCurrentCustomer = createSelector(
  baseData,
  (data) => data.selectedCustomer
);
